import { Box, Link, Typography } from '@veraclins-dev/ui';

import { RemixNavLink } from './nav-link';

type LinkItem = {
  label: string;
  to: string;
};

interface NotFoundProps {
  home?: LinkItem;
  contact?: LinkItem;
  title?: string;
  description?: string;
}

export function NotFound({ home, contact, title, description }: NotFoundProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      items="center"
      justify="center"
      gap={6}
      paddingY={16}
      paddingX={4}
      // oxlint-disable-next-line veraclins-ui/prefer-style-props -- 60vh viewport unit has no scale-token/prop equivalent
      className="min-h-[60vh]"
    >
      <Typography variant="h1" className="text-center">
        404
      </Typography>
      <Typography variant="h2" className="text-center">
        {title || 'Page Not Found'}
      </Typography>
      <Typography
        variant="body1"
        maxW="md"
        className="text-center text-foreground/80"
      >
        {description || 'The page you are looking for does not exist.'}
      </Typography>
      <Box display="flex" gap={4} flexWrap="wrap" justify="center">
        <Link
          to={home?.to ?? '/'}
          component={RemixNavLink}
          type="button"
          emphasis="filled"
          tone="brand"
        >
          {home?.label ?? 'Go Home'}
        </Link>
        {contact?.to.startsWith('http') ? (
          <Link
            href={contact.to}
            target="_blank"
            rel="noopener noreferrer"
            type="button"
            emphasis="outline"
            tone="brand"
          >
            {contact.label ?? 'Contact'}
          </Link>
        ) : (
          <Link
            to={contact?.to ?? '/contact'}
            component={RemixNavLink}
            type="button"
            emphasis="outline"
            tone="brand"
          >
            {contact?.label ?? 'Contact'}
          </Link>
        )}
      </Box>
    </Box>
  );
}
